// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/dietz-erweitert-seine-produktion-nasenbuegel-fuer-schutzmasken-2/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const dietzErweitertSeineProduktionNasenbuegelFuerSchutzmasken2DE: PageEntry = {
  id: "post.dietz-erweitert-seine-produktion-nasenbuegel-fuer-schutzmasken-2",
  locale: "de",
  slug: "dietz-erweitert-seine-produktion-nasenbuegel-fuer-schutzmasken-2",
  seo: {
    title: "EMAS Validierung | Dietz GmbH",
    description: "EMAS Validierung",
  },
  type: "post",
  h1: "EMAS Validierung",
  blocks: [
    { kind: "heading", level: 2, text: "EMAS Validierung" },
    { kind: "paragraph", text: "Mit der erfolgreichen Validierung unseres Umweltmanagementsystems nach EMAS (EU-Verordnung (EG) Nr. 1221/2009) haben wir das weltweit anspruchsvollste System für Umweltmanagement und Umweltleistung in unserem Unternehmen etabliert. Damit leisten wir einen glaubwürdigen und transparenten Beitrag zum nachhaltigen Wirtschaften." }
  ],
};
